/**
 * Environment configuration for Pollen Drawer AI Widget
 *
 * Multi-tenant mode: api-url + api-key are passed at runtime via HTML
 * attributes on each custom element. VITE_API_URL is only used as an optional
 * fallback (e.g. for local development with test-drawer.html and a dev API).
 */

// Helper function for optional env vars with defaults
function getOptionalEnv(key: string, defaultValue: string): string {
  const value = import.meta.env[key];
  return value && value.length > 0 ? value : defaultValue;
}

// Validate and export environment variables
export const env = {
  // API Configuration (optional fallback; per-element `api-url` attribute wins)
  API_URL: getOptionalEnv("VITE_API_URL", ""),

  // Sentry Configuration
  SENTRY_DSN: getOptionalEnv("VITE_SENTRY_DSN", ""),
  SENTRY_ENABLED: getOptionalEnv("VITE_SENTRY_ENABLED", "false") === "true",
  SENTRY_ENVIRONMENT: getOptionalEnv("VITE_SENTRY_ENVIRONMENT", import.meta.env.MODE || "development"),
  SENTRY_TRACES_SAMPLE_RATE: Number.parseFloat(getOptionalEnv("VITE_SENTRY_TRACES_SAMPLE_RATE", "0.1")),

  // Runtime Environment
  MODE: import.meta.env.MODE || "development",
  PROD: import.meta.env.PROD || false,
  DEV: import.meta.env.DEV || false,
} as const;

// Type export for the env object
export type Env = typeof env;
